import {createSelector} from 'reselect';

const selectRaw = (state) => state.tarea.listIncident;

const selectLoading = createSelector([selectRaw], (raw) => raw.loading);

const selectRows = createSelector([selectRaw], (raw) => raw.rows);

const selectCount = createSelector([selectRaw], (raw) => raw.count);

const selectHasRows = createSelector([selectCount], (count) => count > 0);

const selectSorter = createSelector([selectRaw], (raw) => raw.sorter || {});

const selectOrderBy = createSelector([selectRaw], (raw) => {
  const sorter = raw.sorter;
  if (!sorter?.field) return null;
  const direction = sorter.order === 'desc' ? 'DESC' : 'ASC';
  return `${sorter.field}_${direction}`;
});

const selectFilter = createSelector([selectRaw], (raw) => raw.filter);

const selectRawFilter = createSelector([selectRaw], (raw) => raw.rawFilter);

const selectHasFilter = createSelector([selectRaw], (raw) => raw.hasFilter);

const selectLimit = createSelector([selectRaw], (raw) => {
  const pagination = raw.pagination;
  return pagination?.pageSize || 10;
});

const selectOffset = createSelector([selectRaw], (raw) => {
  const pagination = raw.pagination;
  if (!pagination?.pageSize) return 0;
  const current = pagination.current || 1;
  return (current - 1) * pagination.pageSize;
});

const selectPagination = createSelector([selectRaw, selectCount], (raw, count) => ({
  ...raw.pagination,
  total: count,
}));

const selectSelectedKeys = createSelector([selectRaw], (raw) => raw.selectedKeys);

const selectSelectedRows = createSelector([selectRaw, selectRows], (raw, rows) =>
  rows.filter((row) => raw.selectedKeys?.includes(row.id)),
);

const selectIsAllSelected = createSelector([selectRows, selectSelectedKeys], (rows, selectedKeys) =>
  rows.length > 0 && rows.length === (selectedKeys || []).length,
);

const selectListFilterKey = createSelector([selectRaw], (raw) => raw.listFilterKey);

const tareaListIncidentSelectors = {
  selectLoading,
  selectRows,
  selectCount,
  selectOrderBy,
  selectLimit,
  selectFilter,
  selectOffset,
  selectPagination,
  selectSelectedKeys,
  selectSelectedRows,
  selectHasRows,
  selectRawFilter,
  selectIsAllSelected,
  selectSorter,
  selectHasFilter,
  selectListFilterKey,
};

export default tareaListIncidentSelectors;
